import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API_ROOT = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_ROOT,
  timeout: 60000,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("tex_session_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Session token helpers (used by auth.jsx + autoWs.js)
export const getToken = () => localStorage.getItem("tex_session_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("tex_session_token", t);
  else localStorage.removeItem("tex_session_token");
};

// Auth
export const authSession = (session_id) => api.post("/auth/session", { session_id }).then(r => r.data);
export const authMe = () => api.get("/auth/me").then(r => r.data);
export const authLogout = () => api.post("/auth/logout").then(r => r.data);

// Subscription
export const subConfig = () => api.get("/sub/config").then(r => r.data);
export const subMe = () => api.get("/sub/me").then(r => r.data);
export const subCouponCheck = (code) => api.post("/sub/coupon/check", { code }).then(r => r.data);
export const subRedeem = (code) => api.post("/sub/redeem", { code }).then(r => r.data);
export const subSubmit = (payload) => api.post("/sub/submit", payload).then(r => r.data);

// Admin
export const adminSubs = () => api.get("/admin/subs").then(r => r.data);
export const adminSubVerify = (userId, note) => api.post(`/admin/subs/${userId}/verify`, null, { params: note ? { admin_note: note } : {} }).then(r => r.data);
export const adminSubReject = (userId, note) => api.post(`/admin/subs/${userId}/reject`, null, { params: note ? { admin_note: note } : {} }).then(r => r.data);
export const adminUsers = () => api.get("/admin/users").then(r => r.data);
export const adminSessions = () => api.get("/admin/sessions").then(r => r.data);
export const adminUserSetStatus = (userId, status) => api.post(`/admin/users/${userId}/status`, { status }).then(r => r.data);
export const adminCoupons = () => api.get("/admin/coupons").then(r => r.data);
export const adminCouponCreate = (data) => api.post("/admin/coupons", data).then(r => r.data);
export const adminCouponUpdate = (code, data) => api.put(`/admin/coupons/${code}`, data).then(r => r.data);
export const adminCouponDelete = (code) => api.delete(`/admin/coupons/${code}`).then(r => r.data);

// Combined Dashboard + US live marks
export const dashboardOverview = () => api.get("/dashboard/overview").then(r => r.data);
export const usLiveMarks = () => api.get("/us/live-marks").then(r => r.data);

// Part 4 — NAVA-INTRA (adaptive-learning intraday engine)
export const intraStart = (cfg) => api.post("/intra/start", cfg).then(r => r.data);
export const intraStop = () => api.post("/intra/stop").then(r => r.data);
export const intraStatus = () => api.get("/intra/status").then(r => r.data);
export const intraCloseSignal = (sigId) => api.post(`/intra/signals/${sigId}/close`).then(r => r.data);
export const intraLessons = () => api.get("/intra/lessons").then(r => r.data);
export const intraLearning = () => api.get("/intra/learning").then(r => r.data);
export const intraTradesPdfUrl = () => `${API_ROOT}/intra/trades/pdf`;
export const adminAllTradesPdfUrl = () => `${API_ROOT}/intra/admin/trades/pdf`;

// NAVA-US (adaptive-learning US intraday equities/ETF engine)
export const usStart = (cfg) => api.post("/us/start", cfg).then(r => r.data);
export const usStop = () => api.post("/us/stop").then(r => r.data);
export const usStatus = () => api.get("/us/status").then(r => r.data);
export const usCloseSignal = (sigId) => api.post(`/us/signals/${sigId}/close`).then(r => r.data);
export const usLessons = () => api.get("/us/lessons").then(r => r.data);
export const usLearning = () => api.get("/us/learning").then(r => r.data);
export const usNews = () => api.get("/us/news").then(r => r.data);
export const usTradesPdfUrl = () => `${API_ROOT}/us/trades/pdf`;
export const adminAllUsPdfUrl = () => `${API_ROOT}/us/admin/trades/pdf`;

// AI Trade Assistant chat
export const chatSend = (text, session_id) => api.post("/chat/message", { text, session_id }).then(r => r.data);
export const chatHistory = () => api.get("/chat/history").then(r => r.data);
export const chatClear = () => api.delete("/chat/clear").then(r => r.data);
